import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateGroupForm from "../Forms/CreateGroupForm";

interface CreateGroupModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateGroupModal: FC<CreateGroupModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = async () => {
    onSubmit?.();
    handleClose();
  };
  const handleClose = () => {
    onClose();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <CreateGroupForm
        width={550}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default CreateGroupModal;
